import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

export const ProductMostRecentEmpty: FC = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center h-100 px-5 border-bottom border-start border-end">
      <div className="icon text-secondary">history</div>
      <h4 className="text-center text-secondary">
        <FormattedMessage id="productSelector.tab.mostRecent.empty.title" />
      </h4>
      <p className="text-center text-secondary">
        <FormattedMessage id="productSelector.tab.mostRecent.empty.subtitle" />
      </p>
    </div>
  );
};
